import { connectionsResponseSchema } from "@gioia365/contracts";
import { queryOptions } from "@tanstack/react-query";
import { apiRequest } from "../../api/http";
import { tabKey, type TabContext } from "../../session/tab-context";

/**
 * `GET /api/settings/connections` (Impostazioni → «Collegamenti», M7 parte 2): lo stato di ogni collegamento dell'azienda della scheda,
 * in sola lettura. La chiave sta sotto quella della scheda, tolta con le altre al cambio di azienda o di vista.
 */
export function connectionsQuery(tab: TabContext) {
  return queryOptions({
    queryKey: ["scheda", tabKey(tab), "connections"],
    queryFn: ({ signal }) => apiRequest("GET", "/api/settings/connections", { schema: connectionsResponseSchema, tab, signal }),
  });
}
